import { memo, useCallback } from 'react';

import { IKnmSignatureInfo } from 'APIPackage/KnmModule/interfaces/IKnmSignatureInfo';
import { DATE_FORMAT_ISO_FNS, DATE_FORMAT_LONG_FNS } from 'CorePackage/MainModule/constants/dateFormats';
import { formatDate } from 'CorePackage/MainModule/common/formatDate';
import { FieldBlock } from 'UIPackage/FormModule/components/FieldBlock';

import styles from './SignatureBlock.module.scss';

interface ISignatureBlockProps {
  signatureInfo: IKnmSignatureInfo[] | null | undefined;
}

export const SignatureBlock = memo((props: ISignatureBlockProps) => {
  const { signatureInfo } = props;

  /**
   * Функция отрисовки дат
   */
  const renderDate = useCallback((date: string | undefined) => {
    if (!date) {
      return '';
    }

    return formatDate({
      date,
      dateFormat: DATE_FORMAT_LONG_FNS,
      parseFormat: DATE_FORMAT_ISO_FNS,
    });
  }, []);

  return (
    <FieldBlock
      label={'Подпись контролируемого лица'}
      placementLabel="left"
      color="black"
      className={styles.FieldBlock}
    >
      <div className={styles.SignInfoContainer}>
        <div className={styles.SignedContainer}>
          <div>
            <div className={styles.SignedDate}>Подписано {renderDate(signatureInfo?.[0]?.signedDate)}</div>
            <div>Сертификат: {signatureInfo?.[0]?.certInfo?.certNumber}</div>
            <div className={styles.SignedContainerName}>Владелец: {signatureInfo?.[0]?.certInfo?.subject?.name}</div>
            <div>
              Действителен с {renderDate(signatureInfo?.[0]?.certInfo?.validFrom)} по{' '}
              {renderDate(signatureInfo?.[0]?.certInfo?.validTo)}
            </div>
          </div>
          <div className={styles.SignedBorder} />
        </div>
      </div>
    </FieldBlock>
  );
});
